import { data } from 'jquery';
import { auditApi as api } from '../../api';

// export const AttachmentFile = async (recordId, filePath) => {
//   try {
//     if (!recordId || !filePath) {
//       throw new Error("Invalid recordId or filePath");
//     }

//     const token = sessionStorage.getItem("token");

//     const data = {
//       record_id: recordId,
//       file_path: encodeURIComponent(filePath)
//     };

//     const response = await api.post(
//       "/audit_service",
//       data,
//       {
//         responseType: "blob",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     return response;

//   } catch (err) {
//     console.error("AttachmentFile Error:", err);
//     throw err;
//   }
// };


export const AttachmentFile = async (recordId, filePath) => {
  try {
    if (!recordId || !filePath) {
      throw new Error("Invalid recordId or filePath");
    }

    const token = sessionStorage.getItem("token");

    const data = {
      record_id: recordId,
      file_path: filePath, // ✅ NO encodeURIComponent
    };

    const response = await api.post(
      "/audit_service",
      data,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response;

  } catch (err) {
    console.error("AttachmentFile Error:", err);
    throw err;
  }
};





  // export const downloadAttachmentFile = async (id,data) => {
  //     try {
  //         const token = sessionStorage.getItem('token');
  //         const response = await api.get(`/audit-details-download/${id}/${data}`, {
  //             responseType: 'blob',
  //             headers: {
  //                 'Authorization': `Bearer ${token}`
  //             }
  //         });
  //         if (response.status === 200) {
  //           const blob = new Blob([response.data], {
  //               type: response.headers['content-type']
  //           });

  //           const url = window.URL.createObjectURL(blob);
  //           const link = document.createElement('a');
  //           link.href = url;

  //           // ⭐ No filename → browser uses backend filename
  //           link.download = "";

  //           document.body.appendChild(link);
  //           link.click();
  //           link.remove();
  //           return { success: true };
  //       }
  //     } catch (error) {
  //         console.log(error);
  //         throw error.response ? error.response.data.message : error.message;
  //     }
  // }

export const downloadAttachmentFile = async (id, data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/audit-details-download`, 
            {
                record_id: id,
                filename: data
            },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.status === 200) {
            const blob = new Blob([response.data], {
                type: response.headers['content-type']
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = data; // use filename passed in
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // cleanup memory
            return { success: true };
        }
    } catch (error) {
        console.log(error);
        throw error.response ? error.response.data.message : error.message;
    }
}



  export const deleteAttachmentFile = async (id,data) => {
    try {
        const datapass = {
            record_id : id,
            file_name : data
        }
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/vendor-audit/attachment/delete`, datapass, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
  }